import { graphql } from '~/graphql/generated/gql';

export const NO_OP = graphql(`
  query noOp {
    __typename
  }
`);
